<div
  class="preclinical flex flex-col w-full bg-background-tertiary"
  [class.expanded-view]="isExpanded"
  [class.gap-6]="!isExpanded"
  [class.py-6]="!isExpanded"
  [class.min-h-screen]="!isExpanded"
  [class.h-screen]="isExpanded"
  [class.p-0]="isExpanded"
>
  <div
    class="header-section flex flex-col"
    [class.gap-6]="!isExpanded"
    [class.px-8]="isExpanded"
    [class.py-6]="isExpanded"
    [class.gap-3]="isExpanded"
  >
    <div
      class="flex justify-between items-center flex-col md:flex-row gap-4 md:gap-0"
    >
      <h3 class="text-2xl font-bold text-brand-tertiary m-0">
        Ordenes ingresadas
      </h3>
      <div class="flex gap-4 w-full md:w-auto">
        <app-button
          label="Exportar"
          [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
          [size]="ButtonSizeEnum.MD"
          (handleClick)="openExportModal()"
        >
        </app-button>
        <app-button
          label="Añadir muestra"
          leftIcon="icon-mas-blanco"
          [type]="ButtonTypeEnum.PRIMARY"
          [size]="ButtonSizeEnum.MD"
          (handleClick)="openAddSampleModal()"
        >
        </app-button>
      </div>
    </div>

    @if (!isExpanded) {
      <app-metrics-dashboard [metrics]="dashboardMetrics">
      </app-metrics-dashboard>
    }

    <div class="flex flex-col gap-4">
      <div class="flex justify-between items-center gap-4 flex-wrap">
        <div class="flex gap-4">
          <app-button
            label="Filtrar"
            leftIcon="icon-filtro"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleFilterSidebar()"
          >
          </app-button>
          <app-button
            label="Buscar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleSearchControls()"
          >
          </app-button>
          <app-button
            label="Inmovilizar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleFrozenColumnsSidebar()"
          >
          </app-button>
        </div>

        <button
          (click)="toggleExpansion()"
          class="w-10 h-10 min-w-10 min-h-10 border-none bg-transparent cursor-pointer p-0 flex-shrink-0"
          [class.icon-expandir-vista]="!isExpanded"
          [class.icon-contraer-vista]="isExpanded"
          [attr.aria-label]="isExpanded ? 'Contraer vista' : 'Expandir vista'"
          type="button"
        ></button>
      </div>

      @if (showSearchControls()) {
        <div class="search-controls-container animate-fade-in">
          <app-search-controls
            [searchFieldOptions]="searchFieldOptions"
            (searchExecuted)="handleSearch($event)"
            (clear)="handleClearSearch()"
          ></app-search-controls>
        </div>
      }

      @if (hasActiveFilters) {
        <app-active-filters
          [filterCriteria]="currentFilterCriteria"
          (clearFilters)="clearFilters()"
        ></app-active-filters>
      }
    </div>
  </div>

  <div
    class="flex flex-col table-container min-h-0"
    [class.flex-1]="isExpanded"
    [class.overflow-hidden]="isExpanded"
  >
    <app-table
      [items]="orders"
      [visibleColumns]="visibleColumnsComputed()"
      [frozenColumns]="frozenColumnsInOrder()"
      [tableName]="'Órdenes Ingresadas'"
      [tableActions]="tableActions"
      [showActions]="false"
    >
    </app-table>

    <app-paginator
      [totalRegister]="totalRecords"
      (getData)="onPageChange($event)"
    >
    </app-paginator>
  </div>
</div>

<app-frozen-columns-sidebar
  [columns]="availableColumns"
  [isOpen]="isFrozenSidebarOpen"
  (closeSidebar)="closeFrozenColumnsSidebar()"
>
</app-frozen-columns-sidebar>

<app-filter-sidebar
  [isOpen]="isFilterSidebarOpen"
  [hiddenFilters]="['priority', 'reprocess', 'reprocessCause', 'sampleStatus', 'sampleType', 'facility']"
  [filterOptionsService]="getFilterOptionsService()"
  [currentFilters]="currentFilterCriteria"
  (closeSidebar)="closeFilterSidebar()"
  (applyFilters)="handleApplyFilters($event)"
>
</app-filter-sidebar>

<app-export-confirmation-modal
  [isOpen]="isExportModalOpen()"
  [state]="exportModalState()"
  (confirm)="handleExportConfirm()"
  (closeModal)="closeExportModal()"
>
</app-export-confirmation-modal>

<app-floating-sidebar
  [isOpen]="showAddSampleModal()"
  [title]="''"
  [width]="'70%'"
  (closePanel)="closeAddSampleModal()"
>
  @if (showAddSampleModal()) {
    <app-add-sample [showToast]="false" [isModal]="true" (sampleCompleted)="closeAddSampleModal()"></app-add-sample>
  }
</app-floating-sidebar>

<app-toast></app-toast>
